import Table from '@/components/Table'
import { TableData } from '@/components/Table/type'
import { useResaleQuery } from '@/queries/useResaleQuery'
import { Resale } from '@/types/Resale'
import { createColumnHelper } from '@tanstack/react-table'
import { useMemo, useState } from 'react'
import DadosMestreHeader from '../components/DadosMestreHeader'  
import DefaultColumn from '@/components/Table/components/DefaultColumn' 
import TableRowActions from '@/components/Table/components/TableRowActions';
import { useTable } from '@/hooks/useTable'   
import EmployeeDialog from './components/EmployeeDialog'
import { Cog, RefreshCw } from 'lucide-react'
import { TypographyH1, TypographyMuted } from '@/components/ui/typography'
import ButtonWithTooltip from '@/components/ButtonWithTooltip'

export type ResaleTable = TableData<Resale>

const columnHelper = createColumnHelper<Resale>()

const MasterDataResale = () => {
    const {
        table,
        tableState,
        selectedRows,  
        onClickMultiDelete, 
        setTable,  
    } = useTable<Resale>('')
  
    const [isEmployeeDialogOpen, setIsEmployeeDialogOpen] = useState(false)
    const [selectedResale, setSelectedResale] = useState<number>()
    const { data, isFetching, isPending, refetch } = useResaleQuery()

    const onEmployeeDialogClose = () => {
        setIsEmployeeDialogOpen(false)
    }

    const memoData = useMemo(() => data || [], [data])
    const memoColumns = useMemo(
        () => [ 
            columnHelper.accessor('SK_REVENDA', {
                id: 'SK_REVENDA',
                header: 'Cod. Revenda',
                size: 130,
            }), 
            columnHelper.accessor('DS_REVENDA', {
                id: 'DS_REVENDA',
                header: 'Revenda',
                size: 440,
            }), 
            columnHelper.accessor('DD_UF', {
                id: 'DD_UF',
                header: 'UF',
                size: 100,
            }),  
            columnHelper.display({
                id: 'Ações',
                cell: ({ row }) => {  
                    return (
                        (
                            <TableRowActions 
                                submenus={[ 
                                    {
                                        title: 'Ações',
                                        items: [{
                                            label: `Visualizar Funcionários`,
                                            action: () => {row && setSelectedResale(row.original.SK_REVENDA); setIsEmployeeDialogOpen(true) }
                                        }]
                                    }
                                ]} 
                            />
                        )
                    )
                }, 
                size: 60,
                enableColumnFilter: false,
                enableSorting: false, 
            }),  
        ],
        []
    )

    return (
        <div className="flex flex-col h-full overflow-auto p-4">
            
            <div className="flex justify-between">
                <div className="flex flex-col gap-4 justify-between mb-4 sm:items-center sm:flex-row">
                    <div className="flex gap-3 items-center">
                        <div className="flex justify-center items-center w-10 h-10 rounded-lg bg-primary/10">
                            <Cog className="w-5 h-5 text-primary" />
                        </div>
                        <div>
                            <TypographyH1>
                                Revendas
                            </TypographyH1>
                            <TypographyMuted>
                                Consulte as revendas existente na aplicação
                            </TypographyMuted>
                        </div>
                    </div>
                </div>
                
                <div className="flex gap-4 items-center pr-6">
                    <ButtonWithTooltip
                            tooltipContent={<p className="text-white">Atualizar</p>}
                            variant="ghost"
                            onClick={() => refetch()}
                            className="shadow  bg-white"
                        >
                            <RefreshCw size={18} /> 
                    </ButtonWithTooltip>  
                </div>
            </div>
            <div className="w-full h-full overflow-hidden">
                <Table<ResaleTable>
                    data={memoData}
                    columns={memoColumns}
                    getRowId={(row) => row.SK_REVENDA.toString()}
                    isLoading={isPending}
                    isFetching={isFetching}
                    getTableInstance={(table) => setTable(table)}   
                    tableState={tableState}  
                    tableHeader={
                        <DadosMestreHeader
                            title={``}
                            onDelete={onClickMultiDelete}
                            selectedRows={
                                table
                                    ?.getFilteredRowModel()
                                    .flatRows.filter((row) => selectedRows[row.id])
                                    .length
                            }
                        />
                    } 
                    defaultColumn={{
                        cell: ({ getValue }) => (
                            <DefaultColumn>{getValue() as string}</DefaultColumn>
                        ),
                    }}
                /> 
            </div>

            {selectedResale && (
                <EmployeeDialog
                    SK_REVENDA={selectedResale}
                    isOpen={isEmployeeDialogOpen}
                    onClose={onEmployeeDialogClose}
                />
            )} 
        </div>
    )
}

export default MasterDataResale
